<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      section: 'PublicAppLayout'
    }
  },
  head: {
    title: {
      inner: 'Welcome',
      separator: '/',
      complement: 'PatrowlHears'
    },
    // Meta tags
    // meta: [
    //   { name: 'application-name', content: 'Name of my application' },
    //   { name: 'description', content: 'A description of the page', id: 'desc' }, // id to replace intead of create element
    //   // ...
    //   // Twitter
    //   { name: 'twitter:title', content: 'Content Title' },
    //   // with shorthand
    //   { n: 'twitter:description', c: 'Content description less than 200 characters'},
    //   // ...
    //   // Google+ / Schema.org
    //   { itemprop: 'name', content: 'Content Title' },
    //   { itemprop: 'description', content: 'Content Title' },
    //   // ...
    //   // Facebook / Open Graph
    //   { property: 'fb:app_id', content: '123456789' },
    //   { property: 'og:title', content: 'Content Title' },
    //   // with shorthand
    //   { p: 'og:image', c: 'https://example.com/image.jpg' },
    //   // ...
    // ],
    // // link tags
    // link: [
    //   { rel: 'canonical', href: 'http://example.com/#!/contact/', id: 'canonical' },
    //   { rel: 'author', href: 'author', undo: false }, // undo property - not to remove the element
    //   { rel: 'icon', href: require('./path/to/icon-16.png'), sizes: '16x16', type: 'image/png' },
    //   // with shorthand
    //   { r: 'icon', h: 'path/to/icon-32.png', sz: '32x32', t: 'image/png' },
    //   // ...
    // ],
    // script: [
    //   { type: 'text/javascript', src: 'cdn/to/script.js', async: true, body: true}, // Insert in body
    //   // with shorthand
    //   { t: 'application/ld+json', i: '{ "@context": "http://schema.org" }' },
    //   // ...
    // ],
    // style: [
    //   { type: 'text/css', inner: 'body { background-color: #000; color: #fff}', undo: false },
    //   // ...
    // ]
  },
  created () {
    document.title = "PatrowlHears - Vulnerability Intelligence Center";
  },
  // methods: {
  //   logout() {
  //     this.$store.commit("removeToken");
  //     this.$router.push('/auth');
  //   }
  // }
}
</script>


<style>

.v-application {
   /* font-family: 'Proxima Nova'; */
   font-family: 'Roboto';
   /* font-family: $body-font-family, sans-serif !important; */
 }

 .v-application a {
    color: #f57c00;
}
 .v-application .theme--dark .v-footer {
    background-color: #FAFAF7;
  }
/* .theme--dark.v-tabs-items {
  background-color: #F5F5F5;
}

.v-content__wrap {
  /* background: #272727;
  background-color: #272727;
}*/

/* Blink animation */
@-webkit-keyframes blinking {
  0%   { opacity: 1; }
  100% { opacity: 0; }
}

@keyframes blinking {
  0%   { opacity: 1; }
  100% { opacity: 0; }
}

.blink {
  /* animation: blinking .5s infinite; */
  -webkit-animation: blinking 1s infinite backwards alternate;
}


.animated {
  text-indent: 8px;
  /* color:red; */
}

.animated:before {
  content: "Hears";
  animation: topToBottom 3s infinite 0s;
}

@keyframes topToBottom {
  0% {
    content: "Hears";
  }
  50% {
    content: "OffSec";
  }

}

</style>
